import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ContactGroupService } from 'src/app/private/services/contact-group.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-create-contact-group',
  imports: [SharedModule],
  templateUrl: './create-contact-group.component.html',
  styleUrl: './create-contact-group.component.scss'
})
export class CreateContactGroupComponent {

  @Input() type: string = 'Create';
  @Output() closeDialog = new EventEmitter();

  group_name: string = '';
  isSubmitted: boolean = false;

  btnLoading: boolean = false;

  @Input() templateDataToEdit: any;
  @Output() reload = new EventEmitter();




  constructor(
    private api: ContactGroupService,
    private localStorage: LocalStorageService,
    private messageService: MessageService,
  ) { }

  ngOnInit() {
    if(this.type == 'Edit'){
      this.group_name = this.templateDataToEdit.name;
    }
  }


  handleCloseDialog() {
    this.closeDialog.emit();
  }

  
  handleSaveGroup() {

    this.isSubmitted = true;

    if (!this.group_name.trim()) {
      return;
    }

    this.btnLoading = true;
    const payload = {
      name: this.group_name,
      status: "Active",
      total_contacts:1000000,
      organization_id: this.localStorage.getOrganizationId(),
      user_id : this.localStorage.getUserId()
    }


    if(this.type == 'Edit'){

      const payload2 = {
        id : this.templateDataToEdit.id,
        ...payload
      }

      this.api.updateContact_group(payload2).subscribe(
        (res) => {
          this.reload.emit();
          this.isSubmitted = false;
        },
        (err) => {
          console.error(err);
          this.messageService.add({severity:'error', summary:'Error', detail:'Error creating contact group'});
        }
      )

    }else{
      this.api.createContact_group(payload).subscribe(
        (res) => {
          this.reload.emit();
          this.isSubmitted = false;
        },
        (err) => {
          console.error(err);
          this.messageService.add({severity:'error', summary:'Error', detail:'Error creating contact group'});
        }
      )
    }
  }


}
